import React from 'react';
import { useSettings } from '@wix/tpa-settings/react';
import {
  Pages,
  useLocation,
} from '../../../../contexts/Location/LocationContext';

import { classes } from './EmptyList.st.css';

import settingsParams from '../../settingsParams';
import { FCWithChildren } from '@wix/challenges-web-library';

export interface IEmptyListProps {
  title: string;
  onLinkClick?(): void;
}

export const EmptyList: FCWithChildren<IEmptyListProps> = (props) => {
  const settings = useSettings();
  const locationCtx = useLocation();

  return (
    <section className={classes.root}>
      <p className={classes.text}>{props.title}</p>

      <button
        role="link"
        className={classes.cta}
        data-hook="ma-empty-program-link"
        onClick={() => {
          props.onLinkClick && props.onLinkClick();

          locationCtx.goToPage({
            pageId: Pages.List,
          });
        }}
      >
        {settings.get(settingsParams.emptyChallengesLinkText) as string}
      </button>
    </section>
  );
};
